import React, { useEffect } from 'react';
import dayjs, { type ManipulateType } from 'dayjs';
import { Card, Typography, CardContent, Tooltip, Stack, IconButton, Button, Collapse, Checkbox } from '@mui/material';
import { useLang } from '~/hooks/useLang';
import PinIcon from '@mui/icons-material/Pin';
import SpeedIcon from '@mui/icons-material/Speed';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CarCrashIcon from '@mui/icons-material/CarCrash';
import { elapsedTimeInMinutes } from '~/utils/dateTime';
import LocationSearchingIcon from '@mui/icons-material/LocationSearching';
import { Downgraded, useHookstate } from "@hookstate/core";
import useMapState, { useMarkerState } from '~/features/Map/stores/MapState';
import Close from '@mui/icons-material/Close';
import { getHistoricTraceDevice } from '../ModalHistoricDevice/services';
import RouteIcon from '@mui/icons-material/Route';
import RouteOutlinedIcon from '@mui/icons-material/RouteOutlined';
import { authFetch } from '~/services/fetch';
import axios from 'axios';
import L, { LatLng } from 'leaflet';
import { Co2Sharp } from '@mui/icons-material';

// eslint-disable-next-line max-lines-per-function
export default function MarkPopupContentDeviceHistoric({ id, status, code, identifier, plate, date, speed, closeThisPopUp, openThisPopUp, groupId, readonly, agencyName, updatePositionPopup }) {
  const { markers } = useMapState();
  const { popupMarker, forceViewMap, loadingRouteDevice } = useMarkerState()
  const { translate } = useLang();
  const { forceClosePopup, dateTimeHistoric } = useMarkerState();
  const dateTime = dateTimeHistoric.attach(Downgraded).get();
  const existMarker = useHookstate<string[]>([]);


  const changeColorTime = () => {
    const diffTimes = dateTime?.diff(date, 'm', true)
    
    if (diffTimes && diffTimes <= 5) {
      return 'vehicleLastUpdate.online.main';
    } else if (diffTimes && diffTimes > 5 && diffTimes <= 10) {
      return 'vehicleLastUpdate.recent.main';
    } else if (diffTimes && diffTimes > 10) {
      return 'vehicleLastUpdate.offline.main';
    }
  }

  useEffect(() => {
    existMarker.set(Object.keys(markers()['deviceHistoric'].get()).filter((item) => item == String(id)))

    if (!existMarker.get().length) {
      closeThisPopUp()
    } else if (existMarker.get().length && openThisPopUp.get()) {
      updatePositionPopup(
        markers()['deviceHistoric'][id].position.lat.get(),
        markers()['deviceHistoric'][id].position.lng.get(),
        'deviceHistoric',
        markers()['deviceHistoric'][id].get()
      )
    }

  }, [forceClosePopup.get()])


  function calculateHaversineDistance(latitude1, longitude1, latitude2, longitude2) {
    const convertDegreesToRadians = (degrees) => degrees * (Math.PI / 180);

    const earthRadiusKm = 6371; // Raio médio da Terra em quilômetros
    const deltaLatitude = convertDegreesToRadians(latitude2 - latitude1);
    const deltaLongitude = convertDegreesToRadians(longitude2 - longitude1);

    const haversineFormula = Math.sin(deltaLatitude / 2) * Math.sin(deltaLatitude / 2) +
      Math.cos(convertDegreesToRadians(latitude1)) * Math.cos(convertDegreesToRadians(latitude2)) *
      Math.sin(deltaLongitude / 2) * Math.sin(deltaLongitude / 2);

    const centralAngle = 2 * Math.atan2(Math.sqrt(haversineFormula), Math.sqrt(1 - haversineFormula));

    return earthRadiusKm * centralAngle; // Retorna a distância em quilômetros
  }

  const truncateToSixDecimals = (num) => {
    return parseFloat(num.toString().match(/^-?[\d]+(?:\.\d{0,6})?/)[0]);
  }

  const uniqueTraceRoute = (minDistance = 0.03, minTimeDifference = 1) => { // minDistance em km (30 metros)
    const traceRouteRemovedDuplicatePositions = popupMarker['traceRoute']?.get()?.map(item => ({
      lat: truncateToSixDecimals(item.lat),
      lng: truncateToSixDecimals(item.lng),
      statusId: item.statusId,
      datePoint: item.datePoint,
      identifier: item.identifier
    })).filter((itemFiltered, index, self) => {
      const key = `${itemFiltered.lat}-${itemFiltered.lng}-${itemFiltered.statusId}`;
      return index === self.findIndex(itemFinded => `${itemFinded.lat}-${itemFinded.lng}-${itemFinded.statusId}` === key);
    });

    const filteredPositions = [];
    for (let item = 0; item < traceRouteRemovedDuplicatePositions?.length; item++) {
      const current = traceRouteRemovedDuplicatePositions[item];
      let shouldAdd = true;

      for (let points = 0; points < filteredPositions.length; points++) {
        const existing = filteredPositions[points];
        if (current.statusId === existing['statusId']) {
          const distance = calculateHaversineDistance(current.lat, current.lng, existing['lat'], existing['lng']);
          const timeDifference = dayjs(current.datePoint).diff(dayjs(existing['datePoint']), 'minute');
          if (distance <= minDistance && Math.abs(timeDifference) <= minTimeDifference) {
            shouldAdd = false;
            break;
          }
        }
      }

      if (shouldAdd) {
        filteredPositions.push(current as never);
      }
    }

    popupMarker['traceRoute']?.set(JSON.parse(JSON.stringify(filteredPositions)));

  }


  // * GERANDO POSSIVEL ROTA POR ONDE A VIATURA PASSOU
  // const getRouteAlternative = async () => {
  //   const testePoints = popupMarker['traceRoute']?.get().map((item) => [item.lng, item.lat])

  //   await axios('http://192.168.101.88:8989/route?key=', {
  //     method: 'POST',
  //     data: {
  //       points: testePoints,
  //       profile: "car",
  //       elevation: true,
  //       instructions: true,
  //       locale: "pt_BR",
  //       points_encoded: false,
  //       points_encoded_multiplier: 1000000,
  //       details: [
  //         "road_class",
  //         "road_environment",
  //         "max_speed",
  //         "average_speed"
  //       ],
  //       snap_preventions: [
  //         "ferry"
  //       ],
  //       optimize: true,
  //     },
  //   }).then((response) => {
  //     if (response.data) {
  //       const lastItemRemoved = response.data.paths[0].points.coordinates.map((item) => {

  //         return { lat: item[1], lng: item[0] }
  //       })
  //       popupMarker['traceRoute'].set(lastItemRemoved)
  //     }
  //   });
  // }

  const handleHistoricDevice = () => {
    if (popupMarker['traceRoute']?.get()) {
      popupMarker['traceRoute']?.set(null)
      return false
    } else {
      if (markers()['deviceHistoric'][id].get().id && dateTime) {
        loadingRouteDevice.set(true)
        getHistoricTraceDevice({
          deviceId: markers()['deviceHistoric'][id].get().id,
          startDate: dateTime.subtract(30, "minute" as ManipulateType),
          finishDate: dateTime.add(30, "minute" as ManipulateType),
        }).then((response) => {
          const data = response?.data
          data.map((item) => {
            const positions = { lat: item.latitude, lng: item.longitude, statusId: item.device_status_id, datePoint: item.date, identifier: item.identifier }
            popupMarker['traceRoute'].merge([positions])
          })


        }).finally(() => {
          uniqueTraceRoute()
          loadingRouteDevice.set(false)
          forceViewMap().position.set(new LatLng(popupMarker['position'].lat.get(), popupMarker['position'].lng.get()))
        })
      }
    }
  }



  return (
    <Card sx={{ backgroundColor: 'transparent', backgroundImage: 'none', boxShadow: 'none' }}>
      <CardContent sx={{ padding: '1em 0 1em 0' }}>
        <Stack direction='row' alignItems='center'>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
            <Tooltip title={translate('Vehicle')} placement='left'>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <CarCrashIcon sx={{ mr: '10px' }} />
                <Typography variant='subtitle1' sx={{ textAlign: 'left' }}>
                  {markers()['deviceHistoric'][id].get()?.identifier}
                </Typography>
              </div>
            </Tooltip>
            <div style={{ display: 'flex', gap: 2 }}>
              <IconButton size='small' onClick={() => closeThisPopUp()}>
                <Close fontSize='small' />
              </IconButton>
            </div>
          </div>
        </Stack>

        <Tooltip title={translate('Plate')} placement='left'>
          <Stack direction='row' alignItems='center'>
            <PinIcon sx={{ mr: '10px' }} />
            <Typography variant='subtitle1' sx={{ margin: '.4em 0' }} >
              {markers()['deviceHistoric'][id].get()?.plate ? markers()['deviceHistoric'][id].get().plate : 'Não Informado'}
            </Typography>
          </Stack>
        </Tooltip>
        <Tooltip title={translate('Tracking')} placement='left'>
          <Stack direction='row' alignItems='center'>
            <LocationSearchingIcon sx={{ mr: '10px' }} />
            <Typography variant='subtitle1' sx={{ margin: '.4em 0' }} >
              {code ? code : 'Não Informado'}
            </Typography>
          </Stack>
        </Tooltip>
        <Tooltip title={translate('Last update')} placement='left'>
          <Stack direction='row' alignItems='center' >
            <AccessTimeIcon sx={{ mr: '10px', color: changeColorTime() }} />
            <Typography variant='subtitle1' sx={{ margin: '.4em 0', color: changeColorTime() }} >
              {dayjs(date).isValid() ? dayjs(date).format('DD/MM/YYYY HH:mm') : ''}
            </Typography>
          </Stack>
        </Tooltip>
        <Tooltip title={translate('Speed')} placement='left'>
          <Stack direction='row' alignItems='center'>
            <SpeedIcon sx={{ mr: '10px', display: markers()['deviceHistoric'][id].get()?.speed === undefined || markers()['deviceHistoric'][id].get()?.speed === null ? 'none' : 'block' }} />
            <Typography variant='subtitle1' sx={{ margin: '.4em 0', display: markers()['deviceHistoric'][id].get()?.speed === undefined || markers()['deviceHistoric'][id].get()?.speed === null ? 'none' : 'block' }} >
              {markers()['deviceHistoric'][id].get()?.speed}
              {' '}
              km/h
            </Typography>
          </Stack>
        </Tooltip>
        <Stack marginTop={1} spacing={2}>
          <Button variant='contained' sx={{ width: '100%' }} onClick={() => handleHistoricDevice()}>
            {popupMarker['traceRoute']?.get() ? translate('Remove Historical Device') : translate('Historical Device')}
          </Button>
        </Stack>
      </CardContent>

    </Card >
  )
}
